var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowPrevNavi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "25px",
    viewBox: "0 0 19 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Keyboard Arrow - Left / Rounded") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-35.0%",
    y: "-21.0%",
    width: "170.0%",
    height: "142.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.209380661 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9.875,0.778114504 C9.60253736,0.505037689 9.23262989,0.351572996 8.846875,0.351572996 C8.46112011,0.351572996 8.09121264,0.505037689 7.81875,0.778114504 L1.125,7.4718645 C0.55625,8.0406145 0.55625,8.9593645 1.125,9.5281145 L7.81875,16.2218645 C8.3875,16.7906145 9.30625,16.7906145 9.875,16.2218645 C10.44375,15.6531145 10.44375,14.7343645 9.875,14.1656145 L4.21666667,8.49269784 L9.875,2.8343645 C10.44375,2.2656145 10.4291667,1.33228117 9.875,0.778114504 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Option-CardSystem-ShowOption-Copy",
    transform: "translate(-458.000000, -521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PreviousProfile",
    filter: "url(#filter-1)",
    transform: "translate(453.000000, 507.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Keyboard-Arrow---Left-/-Rounded",
    transform: "translate(9.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/chevron_left_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Selected-/-On-Surface-/-Inactive",
    mask: "url(#mask-3)",
    fill: "#000000",
    fillOpacity: 0.54
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.000000, -9.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 35,
    height: 35
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowPrevNavi);
export default __webpack_public_path__ + "static/media/icArrowPrevNavi.4f8256b567e33fad1ec02000a1f019de.svg";
export { ForwardRef as ReactComponent };